module.exports = __webpack_public_path__ + "static/media/horizontal video website (fine).f3ca8a31.mp4";